import React from 'react';
import { DetailSection } from '../common';
import { format } from 'date-fns';

/**
 * Default display for travel types without a specialized component
 */
const DefaultDetails = ({ travel, tripId, RelatedDocumentsSection, onUnlink }) => {
    const { details, cost, startDate, endDate } = travel;

    // Format date for display
    const formatDate = (dateString) => {
        if (!dateString) return 'Not specified';
        try {
            return format(new Date(dateString), 'MMM d, yyyy h:mm a');
        } catch (e) {
            return dateString;
        }
    };

    // Format currency
    const formatCurrency = (amount, currency = 'USD') => {
        if (amount === undefined || amount === null) return 'Not specified';

        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currency
            }).format(amount);
        } catch (e) {
            return `${amount} ${currency}`;
        }
    };

    return (
        <div className="travel-details-container">
            {/* Related Documents moved to StandardDetailsLayout */}

            {/* Basic Info Section */}
            <DetailSection title="Travel Information">
                <div className="details-grid">
                    {startDate && (
                        <div className="detail-item">
                            <div className="detail-label">Start Date</div>
                            <div className="detail-value">{formatDate(startDate)}</div>
                        </div>
                    )}

                    {endDate && (
                        <div className="detail-item">
                            <div className="detail-label">End Date</div>
                            <div className="detail-value">{formatDate(endDate)}</div>
                        </div>
                    )}

                    {cost && (
                        <div className="detail-item">
                            <div className="detail-label">Cost</div>
                            <div className="detail-value">
                                {formatCurrency(cost.amount, cost.currency)}
                                <span className="payment-status">
                                    {cost.paid ? ' (Paid)' : ' (Unpaid)'}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </DetailSection>

            {/* Additional Details Section - renders any other details that exist */}
            {details && Object.keys(details).length > 0 && (
                <DetailSection title="Additional Details">
                    <div className="details-grid">
                        {Object.entries(details).map(([key, value]) => (
                            <div key={key} className="detail-item">
                                <div className="detail-label">
                                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                                </div>
                                <div className="detail-value">
                                    {typeof value === 'string' || typeof value === 'number'
                                        ? String(value)
                                        : JSON.stringify(value)}
                                </div>
                            </div>
                        ))}
                    </div>
                </DetailSection>
            )}
        </div>
    );
};

export default DefaultDetails;
